import { TEXT_KEYS } from 'modules/end-operation/end-operation.constants';

export enum ERROR_TYPE {
    INELIGIBLE = 'INELIGIBLE',
    GENERIC = 'GENERIC',
    CAMPAIGN_STATUS_FAIL = 'CAMPAIGN_STATUS_FAIL',
    CAMPAIGN_STATUS_MAINTENANCE = 'CAMPAIGN_STATUS_MAINTENANCE',
    UBISERVICES_REQUEST_FAIL = 'UBISERVICES_REQUEST_FAIL',
    PLATFORM_NOT_LINKED = 'PLATFORM_NOT_LINKED',
    END_OPERATION = 'END_OPERATION'
}

export const ERROR_PAGE_TEXTS = {
    CAPTION: 'friend-referral-program',
    TITLE: 'landing-page__title'
};

export const ERROR_PAGE_TEXTS_BY_ERROR_TYPE = {
    [ERROR_TYPE.INELIGIBLE]: {
        TITLE: 'error-page__ineligible-title',
        DESCRIPTION: 'error-page__ineligible-description'
    },
    [ERROR_TYPE.GENERIC]: {
        TITLE: 'error-page__generic-title',
        DESCRIPTION: 'error-page__generic-description'
    },
    [ERROR_TYPE.CAMPAIGN_STATUS_FAIL]: {
        TITLE: 'error-page__campaign-status-fail__title',
        DESCRIPTION: 'error-page__campaign-status-fail__description'
    },
    [ERROR_TYPE.CAMPAIGN_STATUS_MAINTENANCE]: {
        TITLE: 'error-page__campaign-status-maintenance__title',
        DESCRIPTION: 'error-page__campaign-status-maintenance__description'
    },
    [ERROR_TYPE.UBISERVICES_REQUEST_FAIL]: {
        TITLE: 'error-page__ubiservices-request-fail__title',
        DESCRIPTION: 'error-page__ubiservices-request-fail__description'
    },
    [ERROR_TYPE.PLATFORM_NOT_LINKED]: {
        TITLE: 'error-page__profile-not-linked__title',
        DESCRIPTION: 'error-page__profile-not-linked__description'
    },
    [ERROR_TYPE.END_OPERATION]: {
        TITLE: TEXT_KEYS.TITLE,
        DESCRIPTION: TEXT_KEYS.MESSAGE
    }
};
